import { InjectionToken } from '@angular/core';

export const WATERMARK = new InjectionToken<string>('watermark');
